import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";

const navigation = [
  ["/", "Home"],
  ["/reunions", "Reunions"],
  ["/college-days", "College Days"],
  ["/stories", "Stories"],
  ["/in-memoriam", "In Memoriam"],
  ["/members", "Class"],
  ["/college", "The College"],
];

export default function AppShell({ children, authenticated, user }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <>
      <div className="grain" aria-hidden="true" />
      <header className="site-header">
        <Link className="wordmark" to="/" aria-label="MACE 95 home">
          <img
            className="wordmark__logo"
            src="/media/brand/mace95-logo.png"
            alt=""
            width="62"
            height="62"
          />
        </Link>

        <button
          className="menu-toggle"
          type="button"
          aria-expanded={open}
          aria-controls="site-navigation"
          onClick={() => setOpen((value) => !value)}
        >
          <span>Menu</span>
          {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>

        <nav id="site-navigation" className={open ? "site-nav is-open" : "site-nav"} aria-label="Main navigation">
          {navigation.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === "/"}>
              {label}
            </NavLink>
          ))}
          <NavLink className="member-pill" to="/members">
            <span className={authenticated ? "status-dot is-live" : "status-dot"} />
            {authenticated
              ? user?.role === "administrator"
                ? "Admin room"
                : user?.role === "classmate"
                  ? "My profile"
                  : "Member room"
              : "Member sign in"}
          </NavLink>
        </nav>
      </header>
      <main id="main">{children}</main>
      <footer className="site-footer">
        <div className="footer-mark" aria-hidden="true">95</div>
        <div className="footer-intro">
          <p className="kicker">Mar Athanasius College of Engineering</p>
          <h2>The class is still in session.</h2>
        </div>
        <div className="footer-links">
          <Link to="/reunions">Reunion archive</Link>
          <Link to="/college-days">College Days archive</Link>
          <Link to="/stories">Class stories</Link>
          <Link to="/in-memoriam">In memoriam</Link>
          <Link to="/members">Member room</Link>
          <Link to="/college">College contacts</Link>
          <a href="https://mace.ac.in/" target="_blank" rel="noreferrer">
            mace.ac.in <ArrowUpRight aria-hidden="true" />
          </a>
        </div>
        <div className="footer-note">
          <span>1991 → 1995 → forever</span>
          <span>Made for the MACE95 family</span>
        </div>
      </footer>
    </>
  );
}
